module.exports = __webpack_public_path__ + "static/media/LapizIntroductionPage.318afe4f.png";